import axios from "axios";
import Cookies from "js-cookie";
import countryDropdown from '../json_data/multi_countries.json'
import { normalizeUrl } from '../components/utils/helpers';


if (process.env.NODE_ENV === 'development') {
  var data = countryDropdown.find(({ dev_url }) => dev_url == window.location.origin)
} else if (process.env.NODE_ENV === 'production') {
  var data = countryDropdown.find(({ url }) => url == normalizeUrl(window.location.origin))
}
axios.defaults.baseURL = data.backedn_api


// Fetch categories
export const Navigationapi = async () => {
  const res = await axios.get("api/getcategorylist");
  return res.data;
};

export const getbannerlistapi = async () => {
  const res = await axios.get("api/getbannerlist");
  return res.data;
};

export const getbrand_weekApi = async () => {
  const res = await axios.get("api/brand_week");
  return res.data;
}

// Fetch search products with query
export const searchapi = async (searchQuery) => {
  const res = await axios.get(`api/searchproducts?str=${searchQuery}`);
  return res.data;
};

export const getalladdresses = async (idaddress) => {
  const res = await axios.get(`api/getalladdresses?idaddress=${idaddress}`, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return res.data;
};

export const GetPlaceOrder = async (userId) => {
  const res = await axios.get(`api/GetPlaceOrder?userId=${userId}`, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return res.data;
};
export const blogByCatId = async (input_data) => {
  const res = await axios.get(`api/blogByCatId?${input_data.key}=${input_data.value}`);
  return res.data;
};

export const bundle_clearance_saleApi = async () => {
  const res = await axios.get(`api/bundle_clearance_sale`);
  return res.data;
};

export const getnationality = async () => {
  const res = await axios.get("api/GetNationality");
  return res.data;
}
export const getblogs = async () => {
  const res = await axios.get("api/blogs");
  return res.data;
}
export const getMyProfile = async () => {
  const res = await axios.get("api/getMyProfile", {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return res.data;
}
export const checkmobileotp = async (input_data) => {
  const res = await axios.post("/api/checkMobile", input_data);
  return res.data;
};
export const checkCouponCode = async (input_data) => {
  const res = await axios.post("/api/checkCouponCode", input_data, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return res.data;
};
export const updateMyProfile = async (input_data) => {
  const res = await axios.post("/api/updateMyProfile", input_data, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return res.data;
};
export const changePassword = async (input_data) => {
  const res = await axios.post("/api/changePassword", input_data, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  })
  return res.data;
}

export const verifyMobileOtp = async (input_data) => {
  const res = await axios.post("/api/verifyMobileOtp", input_data);
  return res.data;
};

export const reSendOtpeOtp = async (input_data) => {
  const res = await axios.post("/api/reSendOtp", input_data);
  return res.data;
};
export const reSendOtpWhatsapp = async (input_data) => {
  const res = await axios.post("/api/reSendOtpWhatsapp", input_data);
  return res.data;
};

export const logiapi = async (input_data) => {
  const res = await axios.post("api/Login", input_data);
  return res.data;
};
export const forgetPassword = async (input_data) => {
  const res = await axios.post("api/forgetPassword", input_data);
  return res.data;
};
export const resetpassword = async (input_data) => {
  const res = await axios.post("api/resetpassword", input_data);
  return res.data;
};

export const cartlist = async (input_data) => {
  const res = await axios.post("api/GetFromCart", input_data, {
    headers: { authorization: 'Barear ' + Cookies.get("jwt_token") }
  });
  return res;
}

export const addToCartApi = async (input_data) => {
  const res = await axios.post("api/AddToCart", input_data, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return res.data;
}

export const deleteUserAddress = async (input_data) => {
  const res = await axios.post("api/deleteUserAddress", input_data, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return res.data;
}
export const saveDefaultAddress = async (input_data) => {
  const res = await axios.post("api/saveDefaultAddress", input_data, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return res.data;
}
export const changeCartQuantity = async (input_data) => {
  const res = await axios.post("api/changeCartQuantity", input_data);
  return res.data;
}
export const removeFromCart = async (input_data) => {
  const res = await axios.post("api/removeFromCart", input_data);
  return res.data;
}
export const CheckEmail = async (input_data) => {
  const res = await axios.post("api/CheckEmail", input_data);
  return res.data;
}
export const checkMobile = async (input_data) => {
  const res = await axios.post("api/checkMobile", input_data, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return res.data;
}
export const getComplaint = async (input_data) => {
  const res = await axios.post("api/getComplaint", input_data,{
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return res.data;
}
export const postpostPlaceOrder = async (input_data) => {
  const res = await axios.post("api/postpostPlaceOrder", input_data,{
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return res.data;
}
export const Signup = async (input_data) => {
  const res = await axios.post("api/Signup", input_data);
  return res.data;
}
export const addComplaint = async (input_data) => {
  const res = await axios.post("api/addComplaint", input_data);
  return res.data;
}
export const trackdataorderid = async (input_data) => {
  const response = await axios.get(`api/myOrder/trackdata?orderid=${input_data.orderid}&contact=${input_data.phone}`, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return response.data;
}

export const myorder = async (input_data) => {
  const response = await axios.get(`api/myOrders?page=${input_data.page}&refid=${input_data.referenceid}`, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return response.data;
}

export const trackdatabyreferencid = async (input_data) => {
  const response = await axios.get(`api/myOrders?page=${input_data.page}&refid=${input_data.referenceid}`, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return response.data;
}




export const getbannerApi = async () => {
  const response = await axios.get("api/getbannerlist");
  return response;
};

export const getdeal_offersApi = async () => {
  const response = await axios.get("api/deal_offers");
  return response;
};

export const getWishListsApi = async () => {
  const response = await axios.get("api/getWishLists", {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return response;
};

export const postWishListApi = async (input_data) => {
  const response = await axios.post("api/postWishList", input_data, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return response;
};

export const updateCartStatusApi = async (input_data) => {
  const response = await axios.post("api/updateCartStatus", input_data, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return response;
};

export const getDealOfTheDayApi = async () => {
  const response = await axios.get("api/getDealOfTheDay");
  return response;
};

export const getSaverZoneApi = async () => {
  const response = await axios.get("api/getSaverZone");
  return response;
};

export const getInfinteScrollItemsApi = async (type,page) => {
  const response = await axios.get(`api/getInfinteScrollItems?type=${type}&page=${page}`);
  return response;
};

export const getTopSellingApi = async () => {
  const response = await axios.get("api/getTopSelling");
  return response;
};

export const getTopPicksApi = async () => {
  const response = await axios.get("api/getTopPicks");
  return response;
};

export const getCatScreenApi = async (slug) => {
  const response = await axios.get(`api/getallcategoryItems?cat_url=${slug}`);
  return response;
};

export const getSubCatScreenApi = async (input_data) => {
  if (input_data.slug1 == undefined) {
    var response = await axios.get(`api/getallsubcategoryItems?subcat_url=${input_data.slug}&page=${input_data.page}`);
  } else {
    var response = await axios.get(`api/getallsubcategoryItems?subcat_url=${input_data.slug}&sub_subcat_url=${input_data.slug1}&page=${input_data.page}`);
  }
  return response;
};

export const getfiltered_items = async (input_data) => {
  const response = await axios.post("api/filtered_items", input_data);
  return response;
};

export const addFeed = async (data) => {
  const response = await axios.post("api/addFeed", data);
  return response;
};

export const getproduct_detail = async (sku) => {
  const response = await axios.get(`api/product_detail?sku=${sku}`);
  return response;
};

export const getcategory_itemsApi = async (sku) => {
  const response = await axios.get(`api/category_items`);
  return response;
};

export const getdeal_of_the_dayApi = async (page) => {
  const response = await axios.get(`api/deal_of_the_day?page=${page}`);
  return response;
};
export const clearance_saleApi = async (page) => {
  const response = await axios.get(`api/clearance_sale?page=${page}`);
  return response;
};

export const gettop_selling_productsApi = async (page) => {
  const response = await axios.get(`api/top_selling_products?page=${page}`);
  return response;
};

export const getLocationsApi = async () => {
  const response = await axios.get(`api/getLocations`);
  return response;
};
export const getAreasApi = async (id) => {
  const response = await axios.get(`api/getAreas?emirateid=${id}`);
  return response;
};

export const getSectionPagesApi = async (id) => {
  const response = await axios.get(`api/saver_zone1?section_id=${id}`);
  return response;
};

export const getAllBrandItemsApi = async (input_data) => {
  const response = await axios.get(`api/getAllBrandItems?brand_id=0&slug=${input_data.slug}&page=${input_data.page}`);
  return response;
};

export const getAllItemsApi = async (slug,page) => {
  const response = await axios.get(`api/getallitems?cat_url=${slug}&page=${page}`);
  return response;
};

export const getSearchResultApi = async (input_data) => {
  const response = await axios.get(`api/search_result_items?string=${input_data.slug}&subcategory=${input_data.subcategoryId}`);
  return response;
};

export const get_relatedItems = async (input_data) => {
  const response = await axios.post(`api/get_relatedItems`, input_data);
  return response;
};

export const postUserAddressApi = async (input_data) => {
  const response = await axios.post(`api/postUserAddress`, input_data, {
    headers: { authorization: "Barear " + Cookies.get("jwt_token") }
  });
  return response;
};
